/** Search values and submitted-query history shared by the desktop header search. */
import type { ChangeEvent } from 'react';

export type HeaderSearchChange = ChangeEvent<HTMLInputElement> | string;
export function getHeaderSearchValue(change: HeaderSearchChange): string {
  return typeof change === 'string' ? change : change.target.value;
}

export function addSubmittedSearch(history: readonly string[], query: string): string[] {
  const submitted = query.trim();
  if (!submitted) return [...history];
  return [submitted, ...history.filter(value => value.toLocaleLowerCase() !== submitted.toLocaleLowerCase())].slice(0, 5);
}
